exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.m-popup[data-v-0be3ab58] {\n  bottom: 70px;\n}\n.m-popup ul li[data-v-0be3ab58] {\n  cursor: pointer;\n  list-style-type: none;\n}\n.m-popup ul li a[data-v-0be3ab58]:hover,\n.m-popup ul li a[data-v-0be3ab58]:focus {\n  background-color: #ddd;\n}\n", ""]);

// exports
